<template>
	<div class="p-grid">
		<div class="p-col-12">
			<div class="card">

        <Toolbar class="p-mb-4">
          <template #start>
            <div style="font-size: 1.4em; color: inherit" class="p-mr-3">{{ $t('Reminders') }}</div>
<!--            <AddNewButton :label="$t('Add')" @click="addNewItem" />-->
          </template>
          <template #end>
            <CustomDropdown id="notification-type"
                            style="min-width: 180px; max-width: 240px;"
                            ref="notificationTypesDropdown"
                            v-model="selectedType"
                            :options="NotificationTypes"
                            :disabled="dataTableIsLoading"
                            :filterPlaceholder="$t('Reminder type')"
                            :filter="false"
                            @change="changeType"
                            :showClear="true">
              <template #value="slotProps">
                <div v-if="slotProps.value">
<!--                  <div>{{ slotProps.value.label[$i18n.locale] }}</div>-->
                  {{ notificationTypeLabel(slotProps.value?.id) }}
                </div>
                <span v-else>{{$t('Reminder type')}}</span>
              </template>
              <template #option="slotProps">
                <div v-if="slotProps.option">
                  {{ notificationTypeLabel(slotProps.option?.id) }}
                </div>
              </template>
            </CustomDropdown>
          </template>
        </Toolbar>

        <!--  Desktop DataTable -->
        <Spinner v-if="isLoading"/>
<!--        <DesktopDataTable v-else-if="!isLoading && !$store.state.tabletLayout"-->
        <DesktopDataTable v-else
                          :dataTableIsLoading="dataTableIsLoading"
                          :showHeader="false"
                          :itemsArrayIsEmpty="itemsArrayIsEmpty"
                          :sort="sort"
                          :showButtons="!!actionButtonsCount"
                          :showSearchInput="false"
                          :actionButtonsCount="actionButtonsCount"
                          @sort-items="sortItems"
                          :headers="[
              {name: 'id', title: 'ID',sortable: false},
              {name: 'type', title: $t('Type'),sortable: false},
              {name: 'order', title: $t('Order'),sortable: false},
              {name: 'Customer', title: $t('Customer'),sortable: false},
              {name: 'customer', title: $t('Phone'), minWidth: '140px', sortable: false},
              // {name: 'is_processed', title: 'Is processed', sortable: true},
              {name: 'sms_text', title: $t('SMS text'), sortable: false},
              // {name: 'send_sms', title: 'Sms', sortable: true},
              // {name: 'send_email', title: 'Email', sortable: true},
              // {name: 'send_system', title: 'System', sortable: true},
              {name: 'need_to_send_at', title: $t('Scheduled send date'), sortable: false},
              {name: 'need_to_send_due', title: $t('Expires at'), sortable: false},
              {name: 'state', title: $t('Status'), sortable: false},
              {name: 'created_at', title: $t('Created'), sortable: false},
          ]">
          <template v-slot:body>
            <tr v-for="(item, index) of items"
                :key="index"
                :class="{'updated-item': isItemUpdated(item.id)}">
              <td>{{ item.id }}</td>
              <td>
                <template v-if="item.type === 3">
<!--                  {{ NotificationTypes.find(n => n.id === item.type)?.label[$i18n.locale] }}-->
                  {{ notificationTypeLabel(item.type) }}
                </template>
                <template v-else>
                  {{ NotificationTypes.find(n => n.id === 7)?.label[$i18n.locale] }}
                </template>
              </td>
              <td>
                <router-link v-if="item.order && item.order.uid && item.order.number"
                             :to="{ path: `/orders/${item.order.uid}` }"
                             target="_blank"
                             draggable="false">
<!--                  <i class="ti-hummer p-mr-1"></i>-->
                  <div>{{ item.order.number }}</div>
                </router-link>
                <i v-else class="ti-minus"/>
              </td>
              <td>
                <CustomerData v-if="item.customer" :user="item.customer"/>
                <i v-else class="ti-minus"/>
              </td>
              <td>
                <span v-if="item.customer && item.customer.phone_code && item.customer.phone_number">
                  +{{ item.customer.phone_code }} {{ item.customer.phone_number }}
                </span>
                <i v-else class="ti-minus"/>
              </td>
<!--              <td>{{ $t(item.is_processed ? 'Yes' : 'No') }}</td>-->
              <td>
                <div v-if="item.sms_text" style="min-width: 300px">{{ item.sms_text }}</div>
                <i v-else class="ti-minus"/>
              </td>
<!--              <td>-->
<!--                <span v-if="item.sms_sent_at">{{ formatDate(item.sms_sent_at, true)}}</span>-->
<!--                <i v-else class="ti-minus"/>-->
<!--              </td>-->
              <td>
                <span v-if="item.need_to_send_at"
                      :class="{'warning-color': !item.sms_sent_at && (item.need_to_send_at * 1000 < +Date.now())}">{{ formatDate(item.need_to_send_at, true)}}</span>
                <i v-else class="ti-minus"/>
              </td>
              <td>
                <span v-if="item.need_to_send_due">{{ formatDate(item.need_to_send_due, true)}}</span>
                <i v-else class="ti-minus"/>
              </td>
              <td class="table-date-line">
                <NotificationStatus :item="item"/>
              </td>
              <td class="table-date-line">
                {{ formatBy(item.created_at, item.creator) }}
              </td>
              <td v-show="actionButtonsCount">
                <div class="actions">
                  <DeleteButton @click="confirmItemDelete(item)"
                                :disabled="dataTableIsLoading"
                                v-show="$store.getters.isAdminOrHigher"/>
                </div>
              </td>
            </tr>
          </template>
        </DesktopDataTable>

        <OwnPaginator v-show="!itemsArrayIsEmpty"
                      :rows="pagination.perPage"
                      :currentPage="pagination.currentPage - 1"
                      :totalPages="pagination.pageCount"
                      :totalRecords="pagination.totalCount"
                      :rowsPerPageOptions="[5,10,25,50,100,200]"
                      :pageLinkSize="11"/>

        <TotalRecordsData :pagination="pagination" :itemsArrayIsEmpty="itemsArrayIsEmpty"/>
			</div>

      <ConfirmDeleteModal :visible="confirmItemDeleteModal"
                          :modalDataIsLoading="modalDataIsLoading"
                          @close="closeConfirmItemDeleteModal"
                          @delete-item="deleteItem"/>
		</div>
	</div>
</template>

<script>
import httpClient from '@/services/http.services'
import formatMixins from "@/mixins/formatMixins";
import datatableMixins from "@/mixins/datatableMixins";
import settings from "@/settings";
import NotificationStatus from "@/pages/overview/components/NotificationStatus";
import NotificationTypes from "@/translations/NotificationTypes";
import showErrorsMixins from "@/mixins/showErrorsMixins";
import CustomerData from "@/components/CustomerData.vue";

export default {
  mixins: [ formatMixins, datatableMixins, showErrorsMixins ],
  components: { NotificationStatus, CustomerData },
	data() {
		return {
      selectedType: null,
      // selectedTypeId: null,
      confirmItemDeleteModal: false,
      itemToDelete: {},
      // employees: [],
      fieldsExpand: 'order,customer.customerStatus,creator',
      apiLink: 'notification',
      deleteItemUrl: 'notification/delete',
      routePath: '/reminders',
      searchData: '',
      sort: {
        column: 'id',
        direction: '-',
      },
      NotificationTypes,
		}
	},
  mounted() {
    this.scrollToTop()
    if (settings.autoLogoutTimeout && this.$store.state.logoutTimestampIsOverdue) return false
    this.checkRouteQuery()
    // if (!this.$store.state.user?.role) return
    this.getPageData()
    this.setSelectedType()
	},
  methods: {
    getPageData() {
      // if (!this.userCanGetData || this.fetchInFlight) return
      // this.checkRouteType()
      this.getItems()
    },
    setSelectedType() {
      if (this.selectedTypeId) {
        const type = NotificationTypes.find(n => n.id === this.selectedTypeId)
        if (type)  this.selectedType = type
      } else {
        this.selectedType = null
      }
    },
    notificationTypeLabel(typeId) {
      const type = NotificationTypes.find(type => Number(type.id) === Number(typeId))

      return type?.label?.[this.$i18n.locale] || type?.label?.en || ''
    },
    // async sendAppointmentNotifications() {
    //   try {
    //     const { status, data } = await httpClient.post('notification/send-appointment-notifications')
    //     console.log(data)
    //     if (status === 200) {
    //       // item.warning = !item.warning
    //     }
    //   } catch(err) {
    //     this.showError(err)
    //   }
    // },
    changeType() {
      // console.log('changeType')
      this.selectedTypeId = this.selectedType ? +this.selectedType.id : null
      const route = {
        route: this.$route.path,
        query: {
          ...this.$route.query,
          type: this.selectedTypeId,
          // page: 1,
        }
      }
      delete route.query.page

      if (!this.selectedTypeId) {
        delete route.query.type
      }
      this.$router.push(route)
    },
    async getItems() {
      if (!this.userCanGetData || this.fetchInFlight) return
      this.$store.commit('SET_FETCH_IN_FLIGHT', true)
      this.dataTableIsLoading = true
      const ctrl = this.setController?.('notifications')
      try {
        const { status, data, headers } = await httpClient({
          url: this.apiLink,
          // method: 'get',
          params: {
            type: this.selectedTypeId,
            page: this.pagination.currentPage,
            'per-page': this.pagination.perPage,
            sort: this.sort.direction + this.sort.column,
            search: this.searchData,
            expand: this.fieldsExpand,
          },
          signal: ctrl?.signal
        })
        // console.log(data)
        // const { status, data, headers } = await httpClient(`${this.apiLink}?page=${this.pagination.currentPage}&per-page=${this.pagination.perPage}&sort=${this.sort.direction + this.sort.column}&search=${this.searchData}&expand=${this.fieldsExpand}`)
        if (status === 200 && data && Array.isArray(data)) {
          const hasPaginationHeaders = !!headers['x-pagination-total-count']
          if (hasPaginationHeaders) {
            this.pagination.totalCount = +headers['x-pagination-total-count']
            this.pagination.pageCount  = +headers['x-pagination-page-count']
          } else {
            this.pagination.totalCount = data.length
            this.pagination.pageCount  = 1
          }

          this.items = data

          if (!data.length) {
            this.pagination.pageCount = 1
            this.pagination.currentPage = 1
          }
        } else {
          this.showUnknownError()
        }
      } catch(err) {
        this.showError(err)
      } finally {
        this.$store.commit('SET_FETCH_IN_FLIGHT', false)
        this.dataTableIsLoading = false
        this.isLoading = false
        if (this._abortors?.notifications === ctrl) {
          this._abortors.notifications = null
        }
      }
    },
	},
  computed: {
    actionButtonsCount() {
      if (this.$store.getters.isAdminOrHigher) {
        return 1
      } else {
        return 0
      }
    },
  }
}
</script>

<style scoped lang="scss">

</style>